import React from 'react';
import './Services.scss';
import { LuCalculator } from "react-icons/lu";
import { HiOutlineDocumentMagnifyingGlass } from "react-icons/hi2";
import { FaMoneyBillTrendUp, FaHandsHoldingChild } from "react-icons/fa6";

// Agregamos iconos extras por si los necesitas para la versión de freelancers
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { PiHeadsetLight } from "react-icons/pi";

export default function Services({ datosNuevos }) { // 👈 🔥 Recibimos la prop aquí

  // 🎯 ENCABEZADOS DINÁMICOS
  const tituloSeccion = datosNuevos?.title || (
    <>
      Soluciones contables y financieras <br />
      para hacer crecer tu empresa
    </>
  );

  const descripcionSeccion = datosNuevos?.description || (
    <>
      Ofrecemos servicios especializados que se adaptan a las necesidades <br />
      de tu negocio, con enfoque fiscal, financiero y estratégico.
    </>
  );

  // Arreglo de base para Empresas (El que ya tenías)
  const serviciosEmpresas = [
    {
      id: 1,
      icono: <LuCalculator />, 
      titulo: "Contabilidad",
      descripcion: "Llevamos tu contabilidad de forma precisa y oportuna cumpliendo con todas tus obligaciones fiscales.",
      features: ["Contabilidad mensual", "Declaraciones fiscales", "Estados financieros", "Cumplimiento SAT"]
    },
    {
      id: 2,
      icono: <HiOutlineDocumentMagnifyingGlass />,
      titulo: "Auditoría",
      descripcion: "Revisamos y evaluamos la información financiera de tu empresa para garantizar transparencia y cumplimiento.",
      features: ["Auditoría financiera", "Auditoría fiscal", "Dictámenes", "Control interno"]
    },
    {
      id: 3,
      icono: <FaMoneyBillTrendUp />,
      titulo: "Finanzas",
      descripcion: "Te ayudamos a tomar mejores decisiones financieras para mejorar la rentabilidad y el crecimiento de tu negocio.",
      features: ["Planeación financiera", "Análisis de resultados", "Presupuestos", "Proyecciones"]
    },
    {
      id: 4,
      icono: <FaHandsHoldingChild />,
      titulo: "Asesoría para pensiones del IMSS",
      descripcion: "Asesoría especializada para que tu empresa y tus colaboradores cumplan y aprovechen al máximo sus beneficios en el IMSS.",
      features: ["Cálculo de pensión", "Modalidades de pensión", "Corrección de semanas", "Asesoría personalizada"]
    }
  ];

  // VALIDACIÓN: Si vienen tarjetas en la prop (de Freelancers), usamos esas mapeadas a la estructura, si no, el de empresas.
  // Mapeamos tus nuevos bloques visuales con iconos limpios
  const serviciosFreelancers = datosNuevos?.tarjetasNuevas ? [
    { id: 1, icono: <LuCalculator />, titulo: "Declaraciones sin complicaciones", descripcion: "Te ayudamos a mantenerte al día con tus obligaciones fiscales.", features: ["Pagos provisionales", "Declaración anual", "Deducciones autorizadas"] },
    { id: 2, icono: <HiOutlineDocumentMagnifyingGlass />, titulo: "Facturación Fácil", descripcion: "Genera tus CFDI de forma práctica y organizada.", features: ["Portales de facturación", "Configuración de conceptos", "Notas de crédito"] },
    { id: 3, icono: <PiHeadsetLight />, titulo: "Atención Personalizada", descripcion: "Resolvemos tus dudas con atención rápida y cercana.", features: ["Dudas sobre el SAT", "Asesoría por WhatsApp", "Respuesta en minutos"] },
    { id: 4, icono: <IoShieldCheckmarkOutline />, titulo: "Servicios 100% en Línea", descripcion: "Gestiona todo desde donde estés, sin vueltas innecesarias.", features: ["Plataforma en la nube", "Carga de archivos fácil", "Acceso 24/7"] }
  ] : null;

  const datosAMapear = serviciosFreelancers || serviciosEmpresas;

  return (
    <section className="services-section">
      {/* ENCABEZADO DE LA SECCIÓN DINÁMICO */}
      <div className="services-header">
        <span className="services-subtitle">{datosNuevos?.subtitle || "SERVICIOS"}</span>
        <h2 className="services-title">{tituloSeccion}</h2>
        <p className="services-description">{descripcionSeccion}</p>
      </div>

      {/* CUADRÍCULA DE TARJETAS DINÁMICA */}
      <div className="services-grid">
        {datosAMapear.map((servicio) => (
          <div key={servicio.id} className="service-card">
            <div className="service-icon">{servicio.icono}</div>
            <h3 className="service-card-title">{servicio.titulo}</h3>
            <div className="card-divider"></div>
            <p className="service-card-desc">{servicio.descripcion}</p>
            
            {/* Lista con palomitas opcional (si el arreglo tiene features) */}
            {servicio.features && servicio.features.length > 0 && (
              <ul className="service-features-list">
                {servicio.features.map((feature, index) => (
                  <li key={index}>
                    <span className="checkmark">✓</span> {feature}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      {/* ENLACE DE ABAJO */}
      <div className="services-footer">
        <a href="#todos-los-servicios" className="services-link">
          <span className="link-icon"></span> Conoce todos nuestros servicios <span className="arrow">→</span>
        </a>
      </div>
    </section>
  );
}